import { render } from "./HistoriquePage.vue?vue&type=template&id=35acf387&ts=true"
import script from "./HistoriquePage.vue?vue&type=script&lang=ts"
export * from "./HistoriquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__